import { Policy } from "../../service/global.service";
import { UntypedFormControl, UntypedFormGroup, UntypedFormBuilder } from "@angular/forms";

/**
 * Controller used for search filters managment
 * 
 * Used for all filters in the application
 */
export class FiltreController {

  public formBuilder = new UntypedFormBuilder()

  /**
   * 
   * @param form 
   * @param l 
   * @param key 
   * 
   * Create subform of versions for variable key
   */
  initFormVOS(form: UntypedFormGroup, list: string[], key: string) {
    for (let elem of list) {
      const place = form.get(key.toLowerCase()) as UntypedFormGroup
      if (!place.get(elem)) {
        place.addControl(elem, new UntypedFormControl(true))
      }
    }
  }

  /**
   * 
   * @param form 
   * @param key 
   * 
   * DELETE any subform (versions forms)
   */
  deleteFormVersion(form: UntypedFormGroup, key: string) {
    const deleteK = form.controls[key] as UntypedFormGroup
    if (deleteK.value != null) {
      let listValueForKey = Object.keys(deleteK.value)
      listValueForKey.forEach((v: string) => {
        deleteK.removeControl(v)
      });
    }
  }

  /**
   * 
   * @param form 
   * @param os 
   * @returns string[]
   * 
   * GET the list of versions (subform) checked for an os in the form os of Filters string[]
   */
  getAllFieldTrueForSpecificValue(form: UntypedFormGroup, value: string) {
    let valuesTrue: string[] = []
    let specificFormGroup = form.controls[value] as UntypedFormGroup
    Object.keys(specificFormGroup.value).forEach((key: string) => {
      if (specificFormGroup.value[key]) {
        valuesTrue.push(key)
      }
    })
    return valuesTrue
  }

  /**
  * 
  * Return a boolean showing if a subform (versions) have SOME of his values checked
  * 
  * @param form 
  * @param key 
  * @returns boolean
  */
  someComplete(form: UntypedFormGroup, key: string) {
    const vtocheck = form.controls[key] as UntypedFormGroup;
    if (!vtocheck) return false;

    const values = Object.values(vtocheck.value);
    const trueCount = values.filter(Boolean).length;

    return trueCount > 0 && trueCount < Object.keys(vtocheck.controls).length;
  }

  /**
   * 
   * Return a boolean showing if a subform (versions) have ALL of his values checked
   * 
   * @param form 
   * @param key 
   * @returns boolean
   */
  updateAllComplete(form: UntypedFormGroup, key: string) {
    const vtocheck = form.controls[key] as UntypedFormGroup
    let all = true
    if (vtocheck.value != null) {
      Object.keys(vtocheck.value).forEach((key: string) => {
        if (!vtocheck.value[key]) {
          all = false
        }
      });
    }
    return all
  }

  /**
   * Check if the form havn't value true (if any chekmark are active)
   * 
   * return false if one is active
   * 
   * @param form 
   * @param key 
   * @returns boolean
   */
  checkIfnoValueTrue(form: UntypedFormGroup, key: string) {
    let no = true
    let vtocheck = form.controls[key] as UntypedFormGroup
    if (vtocheck.value) {
      Object.keys(vtocheck.value).forEach((key: string) => {
        if (vtocheck.value[key]) {
          no = false
        }
      });
    }
    return no
  }

  getPoliciesBWVersions(listPolicies: Policy[]) {
    let mapBwv = new Map<string, number[]>()
    listPolicies.forEach((p: Policy) => {
      if (p.bwVersion?.version) {
        if (mapBwv.has(p.bwVersion.version)) {
          let l = mapBwv.get(p.bwVersion.version)
          if (l && !l.includes(p.bwVersion.id)) {
            l.push(p.bwVersion.id)
            mapBwv.set(p.bwVersion.version, l)
          }
        } else {
          mapBwv.set(p.bwVersion.version, [p.bwVersion.id])
        }
      }
    });
    return mapBwv
  }

  /**
   * 
   * @param listObjects 
   * @param form
   * 
   * Delete all form controls already existings of a form
   * 
   * and add xnew form controls from list l
   */

  initSimpleForm(listObjects: string[], form: UntypedFormGroup) {
    let lkeys = Object.keys(form.value)
    if (lkeys) {
      for (let k of lkeys) {
        form.removeControl(k)
      }
    }
    for (const element of listObjects) {
      form.addControl(element, new UntypedFormControl(false))
    }
  }

  initMetadataSearchForm(bool: boolean, form: UntypedFormGroup) {
    if (bool) {
      form.addControl('metadata', new UntypedFormControl(false))
    } else {
      form.removeControl('metadata')
    }
  }

  /**
   * Return all FormControl of a formgroup checked
   * @param form 
   * @returns 
   */

  getAllFieldTrue(form: UntypedFormGroup) {
    let allK = Object.keys(form.value)
    let kTrue = []
    for (const element of allK) {
      if (form.value[element]) {
        kTrue.push(element)
      }
    }
    return kTrue
  }

  /**
   * 
   * @param formApp 
   * @param formAppVersion 
   * @param lapp 
   * 
   * Init form application
   */

  initFormWithSubForm(form: UntypedFormGroup, subForm: UntypedFormGroup, listObjects: string[]) {
    let lkeys = Object.keys(form.value)
    if (lkeys.length > 0) {
      for (let k of lkeys) {
        form.removeControl(k)
        subForm.removeControl(k)
      }
    }
    listObjects.forEach((element: string) => {
      form.addControl(element, new UntypedFormControl(false))
      subForm.addControl(element, this.formBuilder.group({}))
    });
  }

  /**
   * 
   * @param form 
   * 
   * form is FormGroup( xnumbers of form Controls )
   * 
   * Patch all form values to false 
   */
  resetSimpleForm(form: UntypedFormGroup) {
    Object.keys(form.value).forEach((key: string) => {
      form.patchValue({ [key]: false });
    });
  }

  resetFormAndSubForm(form: UntypedFormGroup, subForm: UntypedFormGroup) {
    Object.keys(form.value).forEach((key: string) => {
      form.patchValue({ [key]: false });
      let version = subForm.controls[key] as UntypedFormGroup
      Object.keys(version.value).forEach((key: string) => {
        version.patchValue({ [key]: false });
      });
    });
  }

  initFormVersionsForValue(form: UntypedFormGroup, list: string[], key: string) {
    let v = form.controls[key] as UntypedFormGroup;
    list.forEach((version: string) => {
      if (!v.contains(version)) {
        v.addControl(version, new UntypedFormControl(true));
      } else {
        v.patchValue({ [version]: true });
      }
    });
  }

}
